var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{attrs:{"title":_vm.$t('search.headers.searchCount')}},[_c('GraphStatistics',{attrs:{"chart-data":_vm.chartData,"display-name":this.$t('search.statistics.count'),"data-loading":_vm.dataLoading}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }